import contactFormImport from './contactForm'
// import contactFormFieldImport from './contactFormField'
import contactFormLimitImport from './contactFormLimit'

export const contactForm = contactFormImport
// export const contactFormField = contactFormFieldImport
export const contactFormLimit = contactFormLimitImport



// WEBPACK FOOTER //
// ./src/store/modules/contact_forms/getters/index.js